import styled from "styled-components";
import React from "react";

import temperatureLineIcon from "../../../../assets/images/weather_icon/temperature_line.png";
import windspeedLineIcon from "../../../../assets/images/weather_icon/windspeed_line.png";
import precipitationLineIcon from "../../../../assets/images/weather_icon/precipitation_line.png";
import humidityLineIcon from "../../../../assets/images/weather_icon/humidity_line.png";
import windspeedLineLightIcon from "../../../../assets/images/weather_icon/windspeed_line_light.png";
import precipitationLineLightIcon from "../../../../assets/images/weather_icon/precipitation_line_light.png";
import humidityLineLightIcon from "../../../../assets/images/weather_icon/humidity_line_light.png";

import s30Icon from "../../../../assets/images/weather_icon/S30.png";
import s10Icon from "../../../../assets/images/weather_icon/S10.png";
import s40Icon from "../../../../assets/images/weather_icon/S40.png";
import s44Icon from "../../../../assets/images/weather_icon/S44.png";
import s45Icon from "../../../../assets/images/weather_icon/S45.png";
import s46Icon from "../../../../assets/images/weather_icon/S46.png";
import s47Icon from "../../../../assets/images/weather_icon/S47.png";
import s11Icon from "../../../../assets/images/weather_icon/S11.png";
import s12Icon from "../../../../assets/images/weather_icon/S12.png";
import s13Icon from "../../../../assets/images/weather_icon/S13.png";
import s14Icon from "../../../../assets/images/weather_icon/S14.png";
import s15Icon from "../../../../assets/images/weather_icon/S15.png";
import s16Icon from "../../../../assets/images/weather_icon/S16.png";
import s17Icon from "../../../../assets/images/weather_icon/S17.png";
import s31Icon from "../../../../assets/images/weather_icon/S31.png";
import s32Icon from "../../../../assets/images/weather_icon/S32.png";
import s33Icon from "../../../../assets/images/weather_icon/S33.png";
import s34Icon from "../../../../assets/images/weather_icon/S34.png";
import s35Icon from "../../../../assets/images/weather_icon/S35.png";
import s36Icon from "../../../../assets/images/weather_icon/S36.png";
import s37Icon from "../../../../assets/images/weather_icon/S37.png";
import s41Icon from "../../../../assets/images/weather_icon/S41.png";
import s42Icon from "../../../../assets/images/weather_icon/S42.png";
import s43Icon from "../../../../assets/images/weather_icon/S43.png";

const weatherIcons = {
    S10: s10Icon,
    S11: s11Icon,
    S12: s12Icon,
    S13: s13Icon,
    S14: s14Icon,
    S15: s15Icon,
    S16: s16Icon,
    S17: s17Icon,
    S30: s30Icon,
    S31: s31Icon,
    S32: s32Icon,
    S33: s33Icon,
    S34: s34Icon,
    S35: s35Icon,
    S36: s36Icon,
    S37: s37Icon,
    S40: s40Icon,
    S41: s41Icon,
    S42: s42Icon,
    S43: s43Icon,
    S44: s44Icon,
    S45: s45Icon,
    S46: s46Icon,
    S47: s47Icon,
    '01d': s10Icon,
    '01n': s10Icon,
    '02d': s30Icon,
    '02n': s30Icon,
    '03d': s40Icon,
    '03n': s40Icon,
    '04d': s40Icon,
    '04n': s40Icon,
    '09d': s41Icon,
    '09n': s41Icon,
    '10d': s31Icon,
    '10n': s31Icon,
    '11d': s40Icon,
    '11n': s40Icon,
    '13d': s43Icon,
    '13n': s43Icon,
    '50d': s40Icon,
    '50n': s40Icon,
  };
  
const getWeatherIconImage = (iconCode) => {
    return weatherIcons[iconCode] || s10Icon;
};

const getWeatherThemeIcon = (iconType, themeMode = "dark") => {
const weatherIcons = {
    dark: {
    windspeed: windspeedLineIcon,
    precipitation: precipitationLineIcon,
    humidity: humidityLineIcon,
    },
    light: {
    windspeed: windspeedLineLightIcon,
    precipitation: precipitationLineLightIcon,
    humidity: humidityLineLightIcon,
    },
};

const theme = weatherIcons[themeMode] || weatherIcons.dark;
    return theme[iconType] || weatherIcons.dark[iconType];
};

// 테마별 컬러 매핑 객체
const themeColors = {
    dark: {
      mainColor: "white",
      MainContainerBackgroundLinearGradient01: "rgba(0, 0, 0, 0.4)",
      MainContainerBackgroundLinearGradient02: "rgba(0, 0, 0, 0.4)",
      MainPanelBackgroundLinearGradient01: "rgba(0, 0, 0, 0.3)",
      MainPanelBackgroundLinearGradient02: "rgba(0, 0, 0, 0.5)",
      MainPanelBackgroundLinearGradient03: "rgba(0, 0, 0, 0.3)",
      MainPanelOutline: "rgba(255, 255, 255, 0.4)",
      WeatherPanelBackgroundLinearGradient01: "rgba(0, 0, 0, 0.3)",
      WeatherPanelBackgroundLinearGradient02: "rgba(0, 0, 0, 0.5)",
      WeatherPanelBackgroundLinearGradient03: "rgba(0, 0, 0, 0.3)",
      WeatherPanelOutline: "rgba(255, 255, 255, 0.4)",
      WeatherLabelColor: "rgba(255, 255, 255, 0.6)",
      bottomMessageBackground: "rgba(255, 255, 255, 0.2)",
    },
    light: {
      mainColor: "black",
      MainContainerBackgroundLinearGradient01: "rgba(255, 255, 255, 0.4)",
      MainContainerBackgroundLinearGradient02: "rgba(255, 255, 255, 0.4)",
      MainPanelBackgroundLinearGradient01: "rgba(255, 255, 255, 0.3)",
      MainPanelBackgroundLinearGradient02: "rgba(255, 255, 255, 0.5)",
      MainPanelBackgroundLinearGradient03: "rgba(255, 255, 255, 0.3)",
      MainPanelOutline: "rgba(255, 255, 255, 0.4)",
      WeatherPanelBackgroundLinearGradient01: "rgba(255, 255, 255, 0.3)",
      WeatherPanelBackgroundLinearGradient02: "rgba(255, 255, 255, 0.5)",
      WeatherPanelBackgroundLinearGradient03: "rgba(255, 255, 255, 0.3)",
      MainPanelOutline: "rgba(255, 255, 255, 0.4)",
      WeatherLabelColor: "rgba(0, 0, 0, 0.6)",
      bottomMessageBackground: "rgba(0, 0, 0, 0.2)",
    },
  };

/**
 * 테마모드에 따른 색상을 가져오는 함수
 * @param {string} colorName - 색상 이름 (예: "mainColor", "MainPanelOutline")
 * @param {string} themeMode - 테마 모드 ("dark" 또는 "light")
 * @returns {string} 해당 테마의 색상 값
 */
const getThemeColor = (colorName, themeMode = "dark") => {
    const theme = themeColors[themeMode] || themeColors.dark;
    return theme[colorName] || themeColors.dark[colorName];
};

// 날씨 패널 컴포넌트 ####################################################################
const MoleculeWeatherPanel = ({
    orientation,
    themeMode,
    weatherData,
}) => {
    const getWeatherStatus = (weather) => {
        switch (weather) {
          case "1": return "맑음";
          case "3": return "구름 많음";
          case "4": return "흐림";
          case "Clear": return "맑음";
          case "Clouds": return "구름 많음";
          case "Rain": return "비";
          case "Drizzle": return "이슬비";
          case "Thunderstorm": return "뇌우";
          case "Snow": return "눈";
          case "Mist":
          case "Fog": return "안개";
          default:
            if (typeof weather === "string") {
              return weather;
            }
            return "-";
        }
      };
    
      const getWeatherIconCode = (skyCode, ptyCode) => {
        return `S${skyCode}${ptyCode}`;
      };
    
      const currentWeatherIcon = weatherData.sky && weatherData.pty ? 
        getWeatherIconCode(
          weatherData.sky,
          weatherData.pty
        ) : weatherData.weatherIcon;
    
    return (
        <WeatherPanel orientation={orientation} themeMode={themeMode}>
        <NewWeatherContentWrapper orientation={orientation}>
          <MainWeatherGroup orientation={orientation}>
            <MainWeatherIconBlock>
              <MainWeatherIcon
                orientation={orientation}
                src={getWeatherIconImage(currentWeatherIcon)}
                alt={weatherData.weather_icon}
              />
            </MainWeatherIconBlock>
            <MainWeatherInfoBlock>
              <WeatherStatus orientation={orientation} themeMode={themeMode}>
                {weatherData.weatherMain}
              </WeatherStatus>
              <MainTemperatureContainer orientation={orientation}>
                <MainTemperatureNumber orientation={orientation} themeMode={themeMode}>
                  {weatherData.temperature}
                </MainTemperatureNumber>
                <MainTemperatureUnit orientation={orientation} themeMode={themeMode}>
                  °C
                </MainTemperatureUnit>
              </MainTemperatureContainer>
            </MainWeatherInfoBlock>
            <MinMaxTemperatureContainer orientation={orientation}>
              <MinMaxTemperature orientation={orientation} themeMode={themeMode}>
                최저 {weatherData.minTemperature}°
              </MinMaxTemperature>
              <MinMaxTemperature orientation={orientation} themeMode={themeMode}>
                최고 {weatherData.maxTemperature}°
              </MinMaxTemperature>
            </MinMaxTemperatureContainer>
          </MainWeatherGroup>
          <div style={{ width: "10px", height: "100%" }} />

          <WeatherDataGroup orientation={orientation}>
            <WeatherDataItem orientation={orientation}>
              <WeatherDataIconContainer orientation={orientation}>
                <WeatherIconContainer orientation={orientation}>
                  <WeatherIcon
                    orientation={orientation}
                    src={getWeatherThemeIcon("windspeed", themeMode)}
                    alt="풍속"
                  />
                </WeatherIconContainer>
                <WeatherLabel orientation={orientation} themeMode={themeMode}>풍속</WeatherLabel>
              </WeatherDataIconContainer>
              <WeatherDataValueContainer orientation={orientation}>
                <WeatherValueNumber orientation={orientation} themeMode={themeMode}>
                  {weatherData.wind}
                </WeatherValueNumber>
                <WeatherValueUnit orientation={orientation} themeMode={themeMode}>m/s</WeatherValueUnit>
              </WeatherDataValueContainer>
            </WeatherDataItem>

            <WeatherDataItem orientation={orientation}>
              <WeatherDataIconContainer orientation={orientation}>
                <WeatherIconContainer orientation={orientation}>
                  <WeatherIcon
                    orientation={orientation}
                    src={getWeatherThemeIcon("precipitation", themeMode)}
                    alt="강수량"
                  />
                </WeatherIconContainer>
                <WeatherLabel orientation={orientation} themeMode={themeMode}>강수량</WeatherLabel>
              </WeatherDataIconContainer>
              <WeatherDataValueContainer orientation={orientation}>
                <WeatherValueNumber orientation={orientation} themeMode={themeMode}>
                  {weatherData.precipitation}
                </WeatherValueNumber>
                <WeatherValueUnit orientation={orientation} themeMode={themeMode}>
                  mm/h
                </WeatherValueUnit>
              </WeatherDataValueContainer>
            </WeatherDataItem>

            <WeatherDataItem orientation={orientation}>
              <WeatherDataIconContainer orientation={orientation}>
                <WeatherIconContainer orientation={orientation}>
                  <WeatherIcon
                    orientation={orientation}
                    src={getWeatherThemeIcon("humidity", themeMode)}
                    alt="습도"
                  />
                </WeatherIconContainer>
                <WeatherLabel orientation={orientation} themeMode={themeMode}>습도</WeatherLabel>
              </WeatherDataIconContainer>
              <WeatherDataValueContainer orientation={orientation}>
                <WeatherValueNumber orientation={orientation} themeMode={themeMode}>
                  {weatherData.humidity}
                </WeatherValueNumber>
                <WeatherValueUnit orientation={orientation} themeMode={themeMode}>%</WeatherValueUnit>
              </WeatherDataValueContainer>
            </WeatherDataItem>
          </WeatherDataGroup>
        </NewWeatherContentWrapper>
      </WeatherPanel>
      );
}

export default MoleculeWeatherPanel;

const WeatherPanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  /* background: linear-gradient(
    136deg,
    ${({ themeMode }) =>
        getThemeColor("WeatherPanelBackgroundLinearGradient01", themeMode)}
      0%,
    ${({ themeMode }) =>
        getThemeColor("WeatherPanelBackgroundLinearGradient02", themeMode)}
      50%,
    ${({ themeMode }) =>
        getThemeColor("WeatherPanelBackgroundLinearGradient03", themeMode)}
      100%
  ); */
  /* border-radius: 20px; */
  /* margin: 10px; */
  /* outline: 3px
    ${({ themeMode }) => getThemeColor("WeatherPanelOutline", themeMode)} solid; */
  /* outline-offset: -3px; */
  /* backdrop-filter: blur(12px); */
  /* padding: 60px; */
  min-height: 0;
  overflow: hidden;
  justify-content: center;

  flex-shrink: 1;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    /* border-radius: 20px; */
    /* margin: 5px; */
    /* padding: 15px; */
    margin: 30px;
  `}
`;

const NewWeatherContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;

  ${({ orientation }) =>
    orientation === "landscape"
      ? `
    gap: 30px;
    justify-content: space-around;
  `
      : `
    gap: 30px;
    justify-content: space-around;
  `}

  align-items: center;
  width: 100%;
  min-height: 0;
  flex-shrink: 1;
`;

const MainWeatherGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 30px;
`;

const MainWeatherIconBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const MainWeatherInfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

const WeatherDataGroup = styled.div`
  ${({ orientation }) =>
    orientation === "landscape"
      ? `
    display: contents;
  `
      : `
    display: flex;
    flex-direction: row;
    gap: 40px;
    justify-content: space-around;
    align-items: center;
  `}
`;

const MainWeatherIcon = styled.img`
  width: 160px;
  height: 160px;
  @media (max-width: 900px) {
    width: 100px;
    height: 100px;
  }
`;

const WeatherInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    flex-direction: row;
    gap: 20px;
    align-items: center;
    justify-content: center;
  `}
`;

const WeatherStatus = styled.div`
  color: ${({ themeMode }) =>
    getThemeColor("mainColor", themeMode)};
  font-size: 2.8rem;
  font-family: Pretendard;
  font-weight: 600;
  text-align: center;
`;

const MainTemperatureContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 4px;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    gap: 2px;
  `}
`;

const MainTemperatureNumber = styled.span`
  color: ${({ themeMode }) =>
    getThemeColor("mainColor", themeMode)};
  font-size: 3.0rem;
  font-family: Poppins;
  font-weight: 500;
  line-height: 1.1;
  text-align: center;
`;

const MainTemperatureUnit = styled.span`
  color: ${({ themeMode }) =>
    getThemeColor("mainColor", themeMode)};
  font-size: 1.4rem;
  font-family: Poppins;
  font-weight: 500;
  line-height: 1.1;
  text-align: center;
`;

const MinMaxTemperatureContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 10px;
  min-width: 110px;
  height: 100%;
`;

const MinMaxTemperature = styled.div`
  color: ${({ themeMode }) =>
    getThemeColor("mainColor", themeMode)};
  font-size: 2.8rem;
  font-family: Pretendard;
  font-weight: 600;
  white-space: nowrap;
`;

const WeatherDataItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 24px;
  width: 120px;
  min-height: 120px;
  max-height: 120px;
  padding: 8px 0;
  box-sizing: border-box;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    gap: 8px;
    padding: 2px 0;
    flex-direction: column;
    width: 90px;
    min-height: 90px;
    max-height: 90px;
  `}
`;

const WeatherDataIconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    gap: 2px;
  `}
`;

const WeatherDataValueContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 4px;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    gap: 2px;
  `}
`;

const WeatherIcon = styled.img`
  width: 48px;
  height: 48px;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    width: 72px;
    height: 72px;
  `}
`;

const WeatherIconContainer = styled.div`
  width: 48px;
  height: 48px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  > * {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain;
  }

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    width: 72px;
    height: 72px;
  `}
`;

const WeatherLabel = styled.div`
  color: ${({ themeMode }) =>
    getThemeColor(
      "WeatherLabelColor",
      themeMode
    )};
  font-size: calc(1.2 * var(--font-scaler));
  font-family: Pretendard;
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    font-size: calc(1.6 * var(--font-scaler));
  `}
`;

const WeatherValueNumber = styled.span`
  color: ${({ themeMode }) =>
    getThemeColor("mainColor", themeMode)};
  font-size: calc(1.8 * var(--font-scaler));
  font-family: Poppins;
  font-weight: 400;
  line-height: 1.2;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    font-size: calc(1.6 * var(--font-scaler));
  `}
`;

const WeatherValueUnit = styled.span`
  color: ${({ themeMode }) =>
    getThemeColor("mainColor", themeMode)};
  font-size: calc(1.1 * var(--font-scaler));
  font-family: Poppins;
  font-weight: 500;
  line-height: 1.2;

  ${({ orientation }) =>
    orientation === "portrait" &&
    `
    font-size: calc(1.2 * var(--font-scaler));
  `}
`;